export default function (data: any) {
  return {
    one: data[1] || 0,
    two: data[2] || 0,
    three: data[3] || 0,
    four: data[4] || 0,
    five: data[5] || 0,
  }
}
